import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';
import TerminalOrangeButton from '../ui/TerminalOrangeButton';
import { terminalColors } from '../../theme/terminalStyles';
import { getLineReferenceLabel } from '../../helpers/stocktakeLineCompare';

const dialogPaperSx = {
  bgcolor: terminalColors.gradientTop,
  backgroundImage: 'none',
  borderRadius: 2,
  m: { xs: 1, sm: 2 },
};

const formatTitle = (product) =>
  `${product?.name || ''} ${product?.modName || ''}`.trim() || '—';

const formatArticle = (product) => {
  const a = product?.article;
  if (a == null || String(a).trim() === '') return '—';
  return String(a).trim();
};

const StocktakeProductPickDialog = ({ open, products, fromERP, onClose, onSelect }) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" PaperProps={{ sx: dialogPaperSx }}>
    <DialogTitle sx={{ fontWeight: 600, color: terminalColors.textPrimary }}>
      Оберіть товар
    </DialogTitle>
    <DialogContent sx={{ pt: 0 }}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Знайдено кілька позицій у каталозі. Оберіть потрібну:
      </Typography>
      <List dense disablePadding>
        {products.map((product) => {
          const article = formatArticle(product);
          const name = formatTitle(product);
          const docQty = fromERP
            ? Number(product.quantityERP ?? 0)
            : Number(product.quantityStock ?? 0);
          const fact = Number(product.quantityActual ?? 0);
          const inStocktake = Boolean(product.inStocktake);
          return (
            <ListItemButton
              key={product.id}
              onClick={() => onSelect(product)}
              sx={{
                borderRadius: 1.5,
                mb: 0.75,
                border: '2px solid',
                borderColor: inStocktake
                  ? terminalColors.accentOrange
                  : 'rgba(183, 177, 197, 0.85)',
                bgcolor: inStocktake ? terminalColors.cardWhite : 'rgba(255, 255, 255, 0.78)',
                boxShadow: inStocktake
                  ? '0 2px 8px rgba(255, 179, 71, 0.25)'
                  : '0 1px 4px rgba(0,0,0,0.05)',
                '&:hover': {
                  bgcolor: inStocktake ? terminalColors.cardWhite : 'rgba(255, 255, 255, 0.92)',
                },
              }}
            >
              <ListItemText
                primary={
                  <Typography variant="body2" color="text.secondary">
                    Артикул: <strong>{article}</strong>
                    {inStocktake ? (
                      <Typography
                        component="span"
                        variant="caption"
                        sx={{ ml: 1, color: 'text.disabled' }}
                      >
                        · у документі
                      </Typography>
                    ) : null}
                  </Typography>
                }
                secondary={
                  <>
                    <Typography variant="body1" fontWeight={600} component="span" display="block">
                      {name}
                    </Typography>
                    <Typography variant="body2" component="span" color="text.secondary">
                      {getLineReferenceLabel(fromERP)}: {docQty} · Факт: {fact}
                    </Typography>
                  </>
                }
              />
            </ListItemButton>
          );
        })}
      </List>
    </DialogContent>
    <DialogActions sx={{ px: 2, pb: 2 }}>
      <TerminalOrangeButton
        fullWidth
        onClick={onClose}
        sx={{
          bgcolor: 'transparent',
          color: 'text.primary',
          boxShadow: 'none',
          '&:hover': { bgcolor: 'rgba(0,0,0,0.04)', boxShadow: 'none' },
        }}
      >
        Скасувати
      </TerminalOrangeButton>
    </DialogActions>
  </Dialog>
);

export default StocktakeProductPickDialog;
